import React from 'react';
import { CheckCircle, AlertTriangle } from 'lucide-react';
interface StatusBadgeProps {
  missingCount: number;
  isScanning: boolean;
}
export function StatusBadge({
  missingCount,
  isScanning
}: StatusBadgeProps) {
  if (isScanning) {
    return <div className="flex items-center gap-2 px-4 py-2 bg-info/10 border border-info/30 rounded-input" data-id="element-357">
        <div className="w-2 h-2 bg-info rounded-full animate-pulse" data-id="element-358" />
        <span className="text-info font-bold tracking-wide text-sm" data-id="element-359">
          Scanning...
        </span>
      </div>;
  }
  if (missingCount > 0) {
    return <div className="flex items-center gap-2 px-4 py-2 bg-critical/10 border border-critical/30 rounded-input" data-id="element-360">
        <AlertTriangle className="w-5 h-5 text-critical" data-id="element-361" />
        <span className="text-critical font-bold tracking-wide text-sm" data-id="element-362">
          {missingCount} Missing
        </span>
      </div>;
  }
  return <div className="flex items-center gap-2 px-4 py-2 bg-success/10 border border-success/30 rounded-input" data-id="element-363">
      <CheckCircle className="w-5 h-5 text-success" data-id="element-364" />
      <span className="text-success font-bold tracking-wide text-sm" data-id="element-365">
        All Clear
      </span>
    </div>;
}